<template>
  <div>
    <svg v-if="soundOn" width="18" height="18" viewBox="0 0 18 18" class="fill-current sound-icon" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_461_12)">
        <path d="M8.04063 1.91972C7.84084 1.7615 7.59581 1.7615 7.39602 1.91972L3.04209 5.40053H0.644607C0.286492 5.39526 0 5.80135 0 6.2971V11.6976C0 12.1934 0.286492 12.5995 0.644607 12.5995H3.04586L7.39979 16.0803C7.7089 16.3282 8.10094 16.1752 8.27812 15.7428C8.33466 15.6056 8.36105 15.4527 8.36105 15.2945V2.69499C8.36482 2.37328 8.24042 2.07794 8.04063 1.91972Z"/>
        <path d="M10.7963 5.73279C10.5739 5.34779 10.1705 5.28451 9.89158 5.59567C9.6164 5.90683 9.57116 6.47115 9.79357 6.86142C10.457 8.13244 10.457 9.8623 9.79357 11.1333C9.57116 11.5183 9.61263 12.0879 9.88781 12.3991C10.163 12.7155 10.5701 12.6522 10.7925 12.2672L10.7963 12.2619C11.848 10.337 11.848 7.65779 10.7963 5.73279Z" />
        <path d="M13.3671 3.03252C13.1447 2.64752 12.7413 2.58424 12.4624 2.8954C12.1872 3.20656 12.142 3.77087 12.3644 4.16115C13.8986 7.03018 13.8986 10.9645 12.3644 13.8336C12.1382 14.2186 12.1834 14.7882 12.4586 15.0993C12.7338 15.4158 13.1409 15.3525 13.3633 14.9675L13.3671 14.9622C15.2594 11.4234 15.2594 6.57134 13.3671 3.03252Z" />
        <path d="M15.9418 0.332452C15.7156 -0.0525467 15.3123 -0.11056 15.0371 0.200603C14.7619 0.511766 14.7204 1.07081 14.9391 1.46108C17.329 5.92812 17.329 12.067 14.9391 16.534C14.7129 16.919 14.7581 17.4886 15.0333 17.7998C15.3085 18.1109 15.7156 18.0529 15.938 17.6679L15.9418 17.6627C18.6861 12.5258 18.6861 5.46928 15.9418 0.332452Z" />
      </g>
      <defs>
        <clipPath id="clip0_461_12">
          <rect width="18" height="18" fill="white"/>
        </clipPath>
      </defs>
    </svg>

    <svg v-else width="18" height="16" viewBox="0 0 18 16" class="fill-current sound-icon" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_126_0)">
        <path
            d="M10.0111 1.69903C9.76238 1.55823 9.45731 1.55823 9.20855 1.69903L3.78762 4.79672H0.80258C0.356702 4.79203 0 5.15342 0 5.59461V10.4007C0 10.8419 0.356702 11.2033 0.80258 11.2033H3.79231L9.21325 14.301C9.59811 14.5216 10.0862 14.3855 10.3068 14.0006C10.3772 13.8786 10.4101 13.7425 10.4101 13.6017V2.38897C10.4148 2.10736 10.2599 1.83984 10.0111 1.69903Z"/>
        <path
            d="M17.7507 9.58873L16.1643 8.00234L17.7507 6.41595C18.0698 6.0968 18.0698 5.57583 17.7507 5.25667C17.4315 4.93752 16.9105 4.93752 16.5914 5.25667L15.005 6.84306L13.4139 5.25198C13.0948 4.93282 12.5738 4.93282 12.2546 5.25198C11.9355 5.57113 11.9355 6.09211 12.2546 6.41126L13.841 7.99765L12.2546 9.58403C11.9355 9.90319 11.9355 10.4242 12.2546 10.7433C12.5738 11.0625 13.0948 11.0625 13.4139 10.7433L15.0003 9.15693L16.5867 10.7433C16.9059 11.0625 17.4268 11.0625 17.746 10.7433C18.0698 10.4289 18.0698 9.90788 17.7507 9.58873Z"/>
      </g>
      <defs>
        <clipPath id="clip0_126_0">
          <rect width="17.99" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </div>


</template>

<script>
export default {
  name: "SoundIcon",
  props: {
    soundOn: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>

</style>